import { Box, Flex, Icon, ScaleFade, Text, useColorModeValue } from '@chakra-ui/react';
import { ApexOptions } from 'apexcharts';
import { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';

import { drawdownChartData } from 'views/trader/trades/variables/types';
import reseticon from 'assets/icons/reseticon.png';
import downicon from 'assets/icons/downicon.png';
import dayjs from 'dayjs';
import { MdOutlineThumbUp } from 'react-icons/md';

const DrawdownChart = (props: { drawdownData: drawdownChartData, hidden: boolean, showtoolbar: boolean, height: string }) => {

    const [nochartdata, setnochartdata] = useState(true);
    const textColorSecondary = useColorModeValue('secondaryGray.700', 'secondaryGray.500');

    useEffect(() => {
        updateChartData();
    }, [props.drawdownData])

    const updateChartData = () => {

        let dd = 0;
        for (let d of props.drawdownData.series[0].data) {
            dd += d;
        }
        setnochartdata(dd === 0);

        if (dd !== 0) {
            setnochartdata(false);
            options.labels = props.drawdownData.axis;
            setVariables({ options: options, series: props.drawdownData.series });
        }
    }

    const options: ApexOptions = {
        chart: {
            toolbar: {
                show: props.showtoolbar,
                offsetY: -20,
                tools: {
                    download: false, //'<img src=' + downicon + ' width="40">',
                    selection: false,
                    zoom: true,
                    zoomin: false,
                    zoomout: false,
                    pan: false,
                    reset: '<img src=' + reseticon + ' width="40">',
                    customIcons: [{
                        icon: '<img src=' + downicon + ' width="40">',
                        index: 0,
                        title: 'download',
                        click: function (chart, options, e) {
                            chart.dataURI().then((imgURI: any) => {
                                const a = document.createElement('a')
                                a.download = 'drawdown_' + dayjs().format("YYYY-MM-DD") + '.png'
                                a.href = imgURI.imgURI;
                                a.click()
                            })
                        }
                    }]
                }
            }
        },
        tooltip: {
            theme: 'dark',
        },
        plotOptions: {
            bar: {
                borderRadius: 5
            }
        },
        fill: {
            type: 'gradient',
            gradient: {
                type: 'vertical',
                shadeIntensity: 0.5,
                opacityFrom: 0.3,
                opacityTo: 0.9,
                colorStops: [[{ offset: 0, color: '#FFC46B', opacity: 1 }, { offset: 100, color: '#FFC46B', opacity: 0.25 }], [{ offset: 0, color: '#EE5D50', opacity: 0.5 }, { offset: 100, color: '#EE5D50', opacity: 1 }]]
            }
        },
        stroke: {
            curve: 'smooth',
            width: [2, 5]
        },
        dataLabels: {
            enabled: false
        },
        legend: {
            show: true,
            fontWeight: 700,
            fontSize: '11px',
            labels: {
                colors: ['#848287', '#848287']
            },
            onItemClick: {
                toggleDataSeries: false
            },
        },
        xaxis: {
            type: 'category',
            labels: {
                show: false,
                formatter: (value) => {
                    return dayjs(value).format('DD MMM YYYY');
                }
            },
            axisBorder: {
                show: false
            },
            axisTicks: {
                show: false,
            }
        },
        yaxis: [{
            title: {
                text: 'DRAWDOWN',
                offsetX: 20,
                style: {
                    color: '#848287',
                    fontSize: '11px',
                    fontWeight: 700,
                }
            },
            labels: {
                show: true,
                align: 'right',
                minWidth: 0,
                maxWidth: 160,
                style: {
                    colors: ['#848287'],
                    fontSize: '11px',
                    fontWeight: 700,
                },
                offsetX: 0,
                offsetY: 0,
                rotate: 0,
                formatter: (value) => {
                    return value.toFixed(2);
                }
            }
        }, {
            opposite: true,
            title: {
                text: '% CHANGE',
                offsetX: -40,
                style: {
                    color: '#848287',
                    fontSize: '11px',
                    fontWeight: 700,
                }
            },
            labels: {
                show: true,
                align: 'right',
                minWidth: 0,
                maxWidth: 160,
                style: {
                    colors: ['#848287'],
                    fontSize: '11px',
                    fontWeight: 700,
                },
                offsetX: 0,
                offsetY: 0,
                rotate: 0,
                formatter: (value) => {
                    return Number(value).toFixed(2) + '%';
                }
            }
        }],
        grid: {
            show: false,
        }
    };

    const [variables, setVariables] = useState({ options: options, series: [{ name: "", data: [], color: "", type: "area" }] });

    return (
        <>
            <Box mt='20px' minH={{base:'350px', md:'550px'}} h='100%' w='100%' p='0px' hidden={props.hidden}>
                <Flex hidden={!nochartdata} justify={'center'} align={'center'} >
                    <ScaleFade initialScale={0.5} in={true} transition={{ exit: { delay: 0.5 }, enter: { duration: 1 } }}>
                        <Box p='10px' color={textColorSecondary} >
                            <Flex direction={'column'} justify={'center'} align={'center'}>
                                <Text color={textColorSecondary} fontSize='md' mt='20px' mb='20px' ms='20px'>No drawdown to display</Text>
                                <Icon as={MdOutlineThumbUp} boxSize={10} />
                            </Flex>

                        </Box>
                    </ScaleFade>
                </Flex>
                <Chart
                    type='area'
                    hidden={nochartdata}
                    options={variables.options}
                    width="100%"
                    height={props.height}
                    series={variables.series}
                />
            </Box>
        </>
    );
};


export default DrawdownChart;